import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/js/modules/breakpoint-editing/constants/breakpoints';

const COL_FRACTION_TOKEN_PATTERN = /^((?:[\w-]+:)*)col-\[(\d+)\/(\d+)\]$/;

const convertColFractionToPercentage = (numerator, denominator) =>
  parseFloat(((numerator / denominator) * 100).toFixed(5));

const buildColPercentageClass = (prefix, percentageValue) => `${prefix}col-[${percentageValue}%]`;

const convertMatchingTokens = (classAttributeValue, breakpoints) =>
  (classAttributeValue || '')
    .split(/\s+/)
    .filter(Boolean)
    .map((token) => {
      const match = token.match(COL_FRACTION_TOKEN_PATTERN);
      const shouldConvert =
        match && breakpoints.some((breakpoint) => token.startsWith(`${breakpoint}:`));

      if (!shouldConvert) {
        return token;
      }

      const [, prefix, numerator, denominator] = match;

      return buildColPercentageClass(
        prefix,
        convertColFractionToPercentage(numerator, denominator)
      );
    })
    .join(' ');

const convertNarrowerColFractionsToPercentages = (classAttributeValue, breakpoint) => {
  if (breakpoint === TABLET_BREAKPOINT) {
    return convertMatchingTokens(classAttributeValue, [MOBILE_BREAKPOINT]);
  }

  if (breakpoint === MOBILE_BREAKPOINT) {
    return convertMatchingTokens(classAttributeValue, []);
  }

  return convertMatchingTokens(classAttributeValue, [TABLET_BREAKPOINT, MOBILE_BREAKPOINT]);
};

export default convertNarrowerColFractionsToPercentages;
